<div class="component-details">
  <fourd-component-header [expert]="expert()" [showExpertPhoneStatus]="true" (close)="onClose()"></fourd-component-header>
  @if (showProductSelectorForCallback) {
  <fourd-product-selector [products]="productListStandardAll()" (selectedProduct)="selectedProductChangedForCallback($event)" [productActionStart]="true"></fourd-product-selector>
  @if (!!moduleConfig?.ExpertsSupported){
  <div class="smallprint">
    <p>
      <span>For entertainment purposes only.</span>&ngsp;
      <span>18+.</span>&ngsp;
      <span class="nowrap">{{config()?.ContactUsEmailAddress}}.</span>
    </p>
  </div>
  }
  }@else{
  @if (member()?.IsLoggedIn) {
  <div>Account balance is <span>{{member()?.AvailableBalance?.AmountFormatted}}</span></div>
  }
  <div class="component-panel">
    @if (!!moduleConfig?.ExpertsSupported)
    {
    @if (!expert()?.IsOnlineForPhone && !expert()?.IsOnlineForOnlineChat) {
    <div>
      <h4>Sorry, I'm not available right now. Please try again later.</h4>
    </div>
    }
    @if (expert()?.IsOnlineForPhone) {
    @if (expert()?.IsBusy) {
    <div>
      <h4>Sorry, I'm in a {{resources?.reading}} right now.</h4>
    </div>
    <div>
      <a tabindex="0" class="component-button button-available"
         (click)="switchToQueue($event)">Show Queue Options</a>
    </div>
    }
    @else if(member()?.QueueExpertId && member()?.QueueExpertId != expert()?.ExpertId && moduleConfig?.QueueWarningEnabled){
    <div class="queue-warning">
      <span>You are currently queueing for {{memberQueueExpertNickname}}</span>
      <div class="help-tooltip-icon">
        <span>
          <span>?</span>
        </span>
        <div class="help-tooltip-tooltip tooltip-above">
          <div>If you start a {{resources?.reading}} with {{expert()?.Nickname}} you'll remain in the queue for {{memberQueueExpertNickname}} and won't be contacted until your {{resources?.reading}} with {{memberQueueExpertNickname}} has finished.</div>
        </div>
      </div>
    </div>
    }
    }
    }
    @if (isCallbackAvailable()) {
    <div>
      @if (!!moduleConfig?.ExpertsSupported){
      <h4>I'll call you back on</h4>
      }
      @else {
      <h4>We'll call you back on</h4>
      }
      <div class="phone-numbers">
        <i>
          <svg><use href="#icon-phone"></use></svg>
        </i>
        <select [formControl]="selectedPhoneNumber" [class.aspNetDisabled]="pollingOnRunning">
          @for (phoneNumber of callbackPhoneNumbers; track phoneNumber) {
          <option [value]="phoneNumber?.PhoneNumberDialling">{{phoneNumber?.PhoneNumberDisplay}}</option>
          }
        </select>
      </div>
    </div>
    @if (member()?.IsLoggedIn) {
    <div>
      <a tabindex="0" class="component-button button-available"
         (click)="chooseProduct($event)">
        @if (callbackCurrentStatus) {
        @if(callbackCurrentStatus?.SvgHref)
        {
        <i><svg><use [attr.href]="callbackCurrentStatus?.SvgHref"></use></svg></i>&ngsp;
        }
        <span>{{callbackCurrentStatus?.Label}}</span>
        }
      </a>
      @if(requestCanBeCancelled && callbackCurrentStatus?.Status > 0){
      <a tabindex="0" (click)="cancelCallbackRequest($event)" class="component-button button-unavailable">Cancel Call</a>
      }
    </div>
    }
    }
  </div>
  }
</div>
@if (showPayment) {
<fourd-payment [expert]="expert()" [products]="getPaymentProducts()" (close)="closePayment($event)"></fourd-payment>
}
@if (modal) {
<fourd-modal [modal]="modal"></fourd-modal>
}
@if(showLogin())
{
<fourd-login [expert]="expert()" (close)="closeLogin()" [productTypeIds]="moduleConfig?.ProductTypeIdsCallback"></fourd-login>
}
